import ReportProblem from '@mui/icons-material/ReportProblem';
import { FormattedMessage } from 'react-intl';
import { PATHS } from '../../config/consts';
import Alert from '../Alert';
import Link from '../Link';
import messages from './messages';

interface IDormakabaAlert {
  companyId: string;
  hasDormakabaAccessForUser: boolean | undefined;
  isGuestPinLength6: boolean;
  isUserPinLength6: boolean;
  isVisitor: boolean;
  isSiteWithDormakabaIntegrationEnabled: boolean | undefined;
  pinLength: number | undefined;
  siteId: string;
}

function DormakabaAlert({
  companyId,
  hasDormakabaAccessForUser,
  isGuestPinLength6,
  isSiteWithDormakabaIntegrationEnabled,
  isUserPinLength6,
  isVisitor,
  pinLength,
  siteId,
}: IDormakabaAlert) {
  if (!isSiteWithDormakabaIntegrationEnabled || !hasDormakabaAccessForUser || pinLength === 6) {
    return null;
  }

  const isApplicablePinLength6 = isVisitor ? isGuestPinLength6 : isUserPinLength6;

  if (isApplicablePinLength6 && !pinLength) {
    return null;
  }

  if (isApplicablePinLength6) {
    return (
      <Alert severity="warning" icon={<ReportProblem />}>
        <FormattedMessage {...messages.userAccessFormPinWarningDormakaba2} />
      </Alert>
    );
  }

  return (
    <Alert severity="warning" icon={<ReportProblem />}>
      <FormattedMessage
        values={{
          br: <span style={{ display: 'block', marginBottom: '8px' }} />,
          link: (chunks) => (
            <Link to={PATHS.SITE_SETTINGS_ACCESS.replace(':companyId', companyId).replace(':siteId', siteId)}>
              {chunks}
            </Link>
          ),
        }}
        {...messages.userPinModalAlertDormakaba}
      />
    </Alert>
  );
}

export default DormakabaAlert;
